import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
  FaPlus,
  FaMinus,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import { Container, ContainerWhite } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Vimeo from '../../components/Vimeo';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Sobre: React.FC = () => {
  const [active, setActive] = useState(false);
  return (
    <>
      <ContainerWhite id="sobre" style={{ background: "none", display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center'}}>
        <div style={{width: '100%', maxWidth: '1000px', margin: '10px auto'}}>
          <img src="/programa/programa5.jpeg" style={{width: '100%'}}/>
        </div>
        <div style={{width: '100%', maxWidth: '1000px', margin: '10px auto'}}>
          <img src="/programa/programa4.jpeg" style={{width: '100%'}}/>
        </div>
        <div style={{width: '100%', maxWidth: '1000px', margin: '10px auto'}}>
          <img src="/programa/programa3.jpeg" style={{width: '100%'}}/>
        </div>
        <div style={{width: '100%', maxWidth: '1000px', margin: '10px auto'}}>
          <img src="/programa/programa2.jpeg" style={{width: '100%'}}/>
        </div>

        <div style={{width: '100%', maxWidth: '1000px', margin: '10px auto'}}>
          <img src="/programa/programa1.jpeg" style={{width: '100%'}}/>
        </div>
      </ContainerWhite>
    </>
  );
};
export default Sobre;
